import ready from "../utils/ready";
import { $, $$ } from "../utils/selector";

import MicroModal from 'micromodal';

ready(() => {
  MicroModal.init({
    openClass: 'is-open',
    disableScroll: false,
    disableFocus: true,
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    debugMode: true
  });
});
